import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { SplashScreenService } from './splash-screen.service';
import { SharedService } from 'src/app/_theme/core/users/user_profile/_services/common-shared.service';
import { UserPreferenceService } from 'src/app/_theme/core/users/user_profile/_services/user-preference.services';

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    standalone: false
})
export class SplashScreenComponent implements OnInit {
  @ViewChild('splashScreen', { static: true }) splashScreen: ElementRef;
  currentTheme: string;

  constructor(
    private el: ElementRef,
    private splashScreenService: SplashScreenService,
    private readonly sharedService: SharedService,
    private readonly cd: ChangeDetectorRef,
    private readonly userPreferenceService: UserPreferenceService
  ) {}

  ngOnInit(): void {

    this.userPreferenceService.splashcurrentUserPreferences$.subscribe((value) => {
      this.cd.detectChanges();
      if(value!=null||value!=undefined) {
       let localTheme=value.theme;
         if(localTheme=='system' || localTheme=='default'){
         const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
         let systemTheme = prefersDark.matches ? "dark-theme" : "light-theme";
         this.currentTheme=systemTheme;
         } else {
         this.currentTheme = localTheme;
        }
      }
    });
    this.splashScreenService.init(this.splashScreen);
  }
}
